export default __webpack_public_path__ + "static/media/sauced_oven_black.cc7f3a6e.png";